export { CarouselHotspots } from './CarouselHotspots';
